module.exports = __webpack_public_path__ + "static/media/city.b0bf6a1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/city.mp4
// module id = pj91
// module chunks = 15